import { IRemoteOrderGroupCreateConfirmService } from "./remoteOrderGroupCreateConfirm.facade";
import { RemoteGroupOrderService } from "../../services/RemoteGroupOrder.service";

export class RemoteOrderGroupCreateConfirmService implements IRemoteOrderGroupCreateConfirmService {

  constructor(private _remoteGroupOrderService: RemoteGroupOrderService) { }

  public get groupName(): string {
    const me = this;
    return me._remoteGroupOrderService.groupName;
  }

}